import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import EmailTemplate from './EmailTemplate'

import Loader from './Loader'

class EmailTemplateWithButtons extends Component {


    render() {
        const data = this.props.data;
        const { t } = this.props
        if (!data) {
            return null;
        }

        return (

            <div>
                <EmailTemplate {...this.props} />
                {this.props.children}
                <div className="clearfix"></div>
                <div className="form-group padding-top no-left-margin btn-toolbar action-buttons d-flex gap-8 align-items-center flex-wrap">
                    <button type="button" className="btn btn-primary btn-sm" onClick={this.props.onSaveClick.bind(this)}>{this.props.mainButtonTitle ? this.props.mainButtonTitle : t('emailtemplatewithbuttons.send')}</button>
                    <button type="button" className="btn btn-default btn-sm" onClick={this.props.onCancelClick.bind(this)}>{t('emailtemplatewithbuttons.cancel')}</button>
                    <Loader />
                </div>
            </div>
        );
    }
}

export default withTranslation()(EmailTemplateWithButtons);